import { Dialog, DialogContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useGetOne, useNotify } from 'react-admin';
import { apiPut } from '../../../brainApi';
import DialogTitle from '../../../components/DialogTitle';
import AddVehicleForm from '../../../components/VehicleForm/AddVehicleForm';
import { getVehicleType } from '../../../VehicleConstants';

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    '& .MuiDialog-paper': {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexBasis: '90%',
      },
      [theme.breakpoints.up('md')]: {
        flexBasis: '50%',
      },
    },
  },
}));

const AddVehicleModal = ({
  swId,
  customer,
  isOpen,
  setIsOpen,
  fetchAppointment,
}) => {
  const classes = useStyles();
  const notify = useNotify();

  const [vehicleData, setVehicleData] = useState(null);
  const [vehicleList, setVehicleList] = useState([]);

  // Fetch full customer record to get vehicles
  const { loading, data: fullCustomerRecord } = useGetOne(
    'customer',
    customer.id,
  );

  useEffect(() => {
    if (fullCustomerRecord?.vehicles) {
      const customerVehicles = fullCustomerRecord.vehicles.map((v) => ({
        ...v,
        type: getVehicleType(v),
      }));
      setVehicleList(customerVehicles);
    }
  }, [fullCustomerRecord]);

  const closeModal = () => {
    setIsOpen(false);
    setVehicleData(null);
  };

  const onSuccess = async (newVehicleData) => {
    await apiPut(`/scheduled-work/${swId}`, { vehicle_id: newVehicleData.id });
    closeModal();
    fetchAppointment();
  };

  const onError = () => {
    notify('Failed to create vehicle', 'warning');
  };

  const onSelectVehicle = (vehicleId) => {
    const selectedVehicle = vehicleList.find((v) => v.id === vehicleId);
    setVehicleData(selectedVehicle);
  };

  const onSaveSelectedVehicle = async () => {
    await apiPut(`/scheduled-work/${swId}`, { vehicle_id: vehicleData.id });
    closeModal();
    fetchAppointment();
  };

  return (
    <Dialog
      onClose={closeModal}
      aria-labelledby="add-vehicle"
      open={isOpen}
      className={classes.dialogRoot}
      maxWidth="sm"
    >
      <DialogTitle id="vehicle-form-dialog-title" onClose={closeModal}>
        Add Vehicle
      </DialogTitle>
      <DialogContent style={{ marginBottom: '20px' }}>
        {loading ? (
          <Typography>Loading vehicles...</Typography>
        ) : (
          <AddVehicleForm
            vehicleData={vehicleData}
            customerId={customer.id}
            customerType="existing"
            onSuccess={onSuccess}
            onError={onError}
            onSelectVehicle={onSelectVehicle}
            onSaveSelectedVehicle={onSaveSelectedVehicle}
            vehicleList={vehicleList}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AddVehicleModal;
